import PropTypes from 'prop-types';
import countriesJson from '@/data/countries.json';

const normalize = value =>
  String(value ?? '')
    .trim()
    .toLocaleLowerCase();

const ReferralCountryCell = ({ country, countryCode }: Record<string, any>) => {
  const normalizedCountryCode = normalize(countryCode);
  const normalizedCountry = normalize(country);
  const match =
    countriesJson.find(
      item => normalize(item['alpha-2']) === normalizedCountryCode
    ) || countriesJson.find(item => normalize(item.name) === normalizedCountry);
  if (!match) return null;

  const label = match.name;
  const flagCode = normalize(match['alpha-2']);

  return (
    <div className="d-flex align-items-center gap-2" dir="rtl" title={label}>
      {flagCode && (
        <img
          src={`https://static.mizfa.tools/flags/${flagCode}.webp`}
          alt={`پرچم ${label}`}
          width="24"
          height="16"
          loading="lazy"
        />
      )}
      <span>{label}</span>
    </div>
  );
};

ReferralCountryCell.propTypes = {
  country: PropTypes.string,
  countryCode: PropTypes.string
};

export default ReferralCountryCell;
